/* eslint-disable react/display-name */

// libraries
import React, { useCallback, useMemo, useRef } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

// custom components
import RealStoryPreview from './RealStoryPreview';

// styled components
import { Flex, SecondaryButton } from 'shared/styledComponents';

// styles
import 'shared/sliderStyles.css';
import devices from 'theme/devices';

const AppendDotsWrapper = styled(Flex)`
  justify-content: center;
  align-items: center;
  margin-top: 40px;

  @media ${devices.mobile} {
    margin-top: 20px;
  }
`;

const Dots = styled(Flex)`
  @media ${devices.mobile} {
    flex-wrap: wrap;
  }
`;

const SliderNextButton = styled(SecondaryButton)<any>`
  margin-left: 20px;

  @media ${devices.mobile} {
    display: none;
  }
`;

interface RealStoriesPreviewProps {
  stories: any[];
  onStoryClick: (url: string) => () => void;
}

const RealStoriesPreview = ({ stories, onStoryClick }: RealStoriesPreviewProps): JSX.Element => {
  const slider: any = useRef(null);

  const handleSliderNextButtonClick = useCallback(() => slider.current.slickNext(), [slider]);

  const settings = useMemo(
    () => ({
      dots: true,
      arrows: false,
      infinite: true,
      touchMove: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            touchMove: true,
          },
        },
      ],

      appendDots: (dots: any): any => (
        <AppendDotsWrapper>
          <Dots as="ul">{dots}</Dots>
          <SliderNextButton onClick={handleSliderNextButtonClick} size="small">
            next journey
          </SliderNextButton>
        </AppendDotsWrapper>
      ),
    }),
    [handleSliderNextButtonClick],
  );

  return (
    <Slider ref={slider} {...settings}>
      {!!stories?.length &&
        stories.map(({ id, featuredQuote, subtitle, photoUrl, seoUrlStructure }: any) => (
          <RealStoryPreview
            key={id}
            url={seoUrlStructure}
            featuredQuote={featuredQuote}
            subtitle={subtitle}
            photoUrl={photoUrl}
            onStoryClick={onStoryClick}
          />
        ))}
    </Slider>
  );
};

export default RealStoriesPreview;
